// src/hooks/useRoutesByVariant.ts
import type { RouteConfig } from '@app/components/router/AppRouter';

export function useRoutesByVariant(_variantId: 'control' | 'user') {
  let routes: RouteConfig[];

  if (process.env.REACT_APP_UI_VARIANT === 'control') {
    // Webpack keeps only this branch when REACT_APP_UI_VARIANT=control
    // and tree-shakes the "user" code away
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    routes = require('@app/Routes/control').default;
  } else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    routes = require('@app/Routes/user').default;
  }

  return routes;
}
